module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h12"
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('img', {
    attrs: {
      "alt": "img5.png",
      "src": "Images/img5.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("HEN")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("Dreamlands")]), _vm._v(" first came out, I was surprised my family read it. Not that it was a bad book—it was just that I didn’t think it would be to their taste, being a gay fantasy in a Japanese setting. I was very surprised, even a bit shocked, that my stepmother’s sister, Sister Thomas, read the book and enjoyed it, skipping over the naughty words and bits, of course. But this sweet, eighty-plus-year-old nun told me she only had one problem with my novel, and it wasn’t the gay sex (she had skipped those parts; she does that in all the romances she reads). It was the fact that she got very confused about who all these people were and how they were related. So this is for you Sister T: a list of who’s who in the Trust and the Dreamlands. The Japanese names are family name first, then given name.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47d19d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/006.vue
// module id = 69
// module chunks = 0